import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

// 
import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';
// 
import { Subscription } from 'rxjs';
// import { ErrorObservable } from 'rxjs';
// 

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { LostPasswordComponent } from './../../../views/lost-password/lost-password.component';
// import { PasswordStrengthWidgetComponent } from './../password-strength-widget/password-strength-widget.component';
import { UserAvitarModalUploadComponent } from './../../../admin/users/user-avitar-modal-upload/user-avitar-modal-upload.component';
// import { UserPasswordExpiredModalComponent } from './../user-password-expired-modal/user-password-expired-modal.component';
import { HotToastService } from '@ngneat/hot-toast';
import { UserPasswordExpiredModalComponent } from 'src/app/components/users/user-password-expired-modal/user-password-expired-modal.component';
import { DropDownList, DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';
import { EditorManager, InsertHtml, QuickToolbarSettingsModel, RichTextEditorComponent } from '@syncfusion/ej2-angular-richtexteditor';
import { WooPromotionVariableModalComponent } from '../../system-variables/woo-promotion-variable-modal/woo-promotion-variable-modal.component';
import { DataUtil, Predicate, Query } from '@syncfusion/ej2-data';
declare var jQuery:any;
// import { DateTime, Settings } from 'luxon'; // new luxon stuff
@Component({
  selector: 'app-html-editor-modal-widget',
  templateUrl: './html-editor-modal-widget.component.html',
  styleUrls: ['./html-editor-modal-widget.component.scss']
})
export class HtmlEditorModalWidgetComponent implements OnInit, OnChanges {


   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'full'; // side | abstract | full
  @Input() current_field_name?;

  user_id: any;
  baseUploadURL: string;
  brandMysql: any;
  user_level: any;
  baseBrandUploadURL: string;
  users: any;
  brand_id: any;
  access_level: any;


  public sparklineData:Array<any> = [34, 43, 43, 35, 44, 32, 44, 52];
  public sparklineData2:Array<any> = [32, 11, 25, 37, 41, 32, 34, 42];
  public sparklineOptions:any = {type: 'line', width: '100%', height: '50', lineColor: '#1ab394', fillColor: "transparent"};

  public peityType1:string = "bar";
  public peityType2:string = "line";
  public peityOptions1:any = { fill: ["#1ab394", "#d7d7d7"], width:100};
  public peityOptions2:any = { fill: ["#1ab394", "#d7d7d7"]};
  public peityOptions3:any = { fill: '#1ab394', stroke:'#169c81'};
  userLogs: any;
  metric_1_data: any;
  count_of_items: number;
  brand_data: any;
  modalRef: BsModalRef;
  bsModalRef: BsModalRef; // for components
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  current_base_route: string;
  metric_qualification_renewal_date: Date;
  brand: any;
  today_format: Date;
  agent_qualification_status_expired: number;
  user_password_expriry_date: any;
  metric_password_date: Date;
  user_password_date_status_expired: number;
  user_password_expiry_date: any;
  model: any;

  // Luxon
  // :: @ https://stackblitz.com/edit/angular-date-pipe-and-luxon?file=app%2Fluxon.component.ts
  // DSTs: DateTime[];
  // notDSTs: DateTime[];
  // DATETIME_HUGE = DateTime.DATETIME_HUGE;




  public insertImageSettings = {
    display: 'inline'
};

public mode: string = 'Markdown'; // Sets and removes for safe HTML/Sanitise etc  HTML | Markdown

@ViewChild('defaultRTE', {static: false}) defaultRTE;
@ViewChild('RTEmail_template_owner', {static: false}) RTEemail_template_owner;

@ViewChild('paragraphTemplateEditor', {static: false}) paragraphTemplateEditor;
@ViewChild('email_template_client', {static: false}) email_template_client;
@ViewChild('email_privacy_template_client', {static: false}) email_privacy_template_client;

@ViewChild('email_template_owner', {static: false}) email_template_owner;
@ViewChild('email_privacy_template_owner', {static: false}) email_privacy_template_owner;

@ViewChild('email_template_agent', {static: false}) email_template_agent;
@ViewChild('email_privacy_template_agent', {static: false}) email_privacy_template_agent;

@ViewChild('note_template_owner', {static: false}) note_template_owner;
@ViewChild('note_privacy_template_owner', {static: false}) note_privacy_template_owner;

@ViewChild('note_template_client', {static: false}) note_template_client;
@ViewChild('note_privacy_template_client', {static: false}) note_privacy_template_client;

@ViewChild('note_template_agent', {static: false}) note_template_agent;
@ViewChild('note_privacy_template_agent', {static: false}) note_privacy_template_agent;



@ViewChild('ejDialog', {static: false}) defaultDialog;
@ViewChild('ddlelement2', {static: false}) 
public countryObj: DropDownListComponent; 
public dropDownListObject: DropDownList
public editorManager: EditorManager; 
public proxy:any
public isParentDropdownChanged: boolean = false;
public rteObj: RichTextEditorComponent;

public dropdownVariables: DropDownList
@ViewChild("sample")
public listObj: DropDownListComponent;
  note_types: any;

  promotion_id: any;

  dropdownVariablesOrder: DropDownList;
  dropdownVariablesOrderSender: DropDownList;
  dropdownVariablesOrderPickList: DropDownList;
  variable_code_blocks_metrix_search_full: any;
  variable_code_blocks_metrix_search_full_results: any;
  new_data: any;
  search_model: {  };

  dynamic_dropdownVariables: DropDownList
  dynamic_data: { [key: string]: Object; }[];
  dropdownVariablesDynamic: DropDownList;
  dropdownVariables_AutomationGeneral: DropDownList;
  automationGeneral_data: { [key: string]: Object; }[];
  subject_template_doc: any;
  job_dropdown_data: any;
  field_name: string;
  set_value: any;


  public opened() {
    this.defaultRTE.refreshUI();
    // this.RTEemail_template_owner.refreshUI();
  }
  
  // base product sample model based on Order ID 19348
  
  
  // my custom drop downs
  public height: any = '450px';
  
  public job_fields: Object = { text: 'Name', value: 'insertValue' };
public job_fields_categories: Object = { groupBy: 'Category', text: 'Name', value: 'insertValue' };


  public tools: object = {
    type: 'MultiRow',
        items: [ 
          'CreateTable',  '|' ,
          // {
          //   tooltipText: "PlaceHolder DropDown",        
          //   template:
          //     '<table><tr><td><input type="text" tabindex="1" id="ddlelement" /></td></tr></table>'
          // },
           '|',
        //   {
        //     tooltipText: 'Insert My Brand Variables',
        //     template: '<input type="text" id="dropdownVariables"/>'
        // },
        {
          tooltipText: '-- Dynamic Variable Chooser --',
          template: '<input type="text" id="dropdownVariablesDynamic" />'
      },
    //   {
    //     tooltipText: 'Automation General',
    //     template: '<input type="text" id="dropdownVariablesAutomationGeneral" />'
    // },
    //     {
    //       tooltipText: 'Order Variables',
    //       template: '<input type="text" id="dropdownVariablesOrder" />'
    //   },
    //   {
    //     tooltipText: 'Order Sender',
    //     template: '<input type="text" id="dropdownVariablesOrderSender" />'
    // },
    //   {
    //     tooltipText: 'Pick List Items',
    //     template: '<input type="text" id="dropdownVariablesOrderPickList" />'
    // },
       '|',
      // {
      //   tooltipText: 'Insert/Upload Image',
      //   undo: true,
      //   click: this.onClickImageButton.bind(this),
      //   template: '<button type="button" class="btn btn-default"><i class="fa fa-photo"></i></button>'
      // },
      {
        tooltipText: 'Insert Variables Or Images',
        undo: true,
        click: this.onClickPromotionButton.bind(this),
        template: '<button type="button" class="btn btn-warning"><i class="fa fa-code"></i> Insert Variables</button>'
      },
       '|',      
    'Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat',
    'SourceCode', 'FullScreen', '|', 'Undo', 'Redo', '|', 
  
    ]
    };
  
    public pasteCleanupSettings: object = {
      prompt: true,
      plainText: false,
      keepFormat: false,
      deniedTags: ['a'],
      deniedAttrs: ['class', 'title', 'id'],
      allowedStyleProps: ['color', 'margin', 'font-size']
  }; 
    // Repalce
   public quickToolbarSettings: QuickToolbarSettingsModel = {
      image: [
           'Align', 'Caption', 'Remove', 'InsertLink', 'OpenImageLink', '-',
          'EditImageLink', 'RemoveImageLink', 'Display', 'AltText', 'Dimension'
      ],
      table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
  };


  public simpleToolBar_paragraph_TemplateEditor: object = {
    type: 'Expand',
    enableFloating: false,
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    {
      tooltipText: 'Insert Widget',
      undo: true,
      click: this.onClickPromotionButton_paragraphTemplate.bind(this),
      template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
    },
    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat', 'Print',
    'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'
  ],
  table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
    };    

    public simpleToolBar_email_template_client: object = {
      type: 'Expand',
      enableFloating: false,
      items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
      'LowerCase', 'UpperCase', '|',
      {
        tooltipText: 'Insert Widget',
        undo: true,
        click: this.onClickPromotionButton_ClientEmail_Template.bind(this),
        template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
      },
      'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
      'Outdent', 'Indent', '|',
      'CreateLink', '|', 'ClearFormat', 'Print',
      'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'
    ],
    table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
      };       
  
      public simpleToolBar_email_privacy_template_client: object = {
        type: 'Expand',
        enableFloating: false,
        items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
        'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
        'LowerCase', 'UpperCase', '|',
        {
          tooltipText: 'Insert Widget',
          undo: true,
          click: this.onClickPromotionButton_ClientEmailPrivacy_Template.bind(this),
          template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
        },
        'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
        'Outdent', 'Indent', '|',
        'CreateLink', '|', 'ClearFormat', 'Print',
        'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'
      ],
      table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
        };       
    
        public simpleToolBar_email_template_owner: object = {
          type: 'Expand',
          enableFloating: false,
          items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
          'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
          'LowerCase', 'UpperCase', '|',
          {
            tooltipText: 'Insert Widget',
            undo: true,
            click: this.onClickPromotionButton_OwnerEmail_Template.bind(this),
            template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
          },
          'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
          'Outdent', 'Indent', '|',
          'CreateLink', '|', 'ClearFormat', 'Print',
          'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'
        ],
        table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
          };  



          public simpleToolBar_email_privacy_template_owner: object = {
            type: 'Expand',
            enableFloating: false,
            items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
            'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
            'LowerCase', 'UpperCase', '|',
            {
              tooltipText: 'Insert Widget',
              undo: true,
              click: this.onClickPromotionButton_OwnerEmailPrivacy_Template.bind(this),
              template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
            },
            'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
            'Outdent', 'Indent', '|',
            'CreateLink', '|', 'ClearFormat', 'Print',
            'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'
          ],
          table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
            };  
            
            
            public simpleToolBar_email_template_agent: object = {
              type: 'Expand',
              enableFloating: false,
              items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
              'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
              'LowerCase', 'UpperCase', '|',
              {
                tooltipText: 'Insert Widget',
                undo: true,
                click: this.onClickPromotionButton_AgentEmail_Template.bind(this),
                template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
              },
              'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
              'Outdent', 'Indent', '|',
              'CreateLink', '|', 'ClearFormat', 'Print',
              'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'
            ],
            table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
              };  

            
              public simpleToolBar_email_privacy_template_agent: object = {
                type: 'Expand',
                enableFloating: false,
                items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
                'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
                'LowerCase', 'UpperCase', '|',
                {
                  tooltipText: 'Insert Widget',
                  undo: true,
                  click: this.onClickPromotionButton_AgentEmailPrivacy_Template.bind(this),
                  template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
                },
                'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
                'Outdent', 'Indent', '|',
                'CreateLink', '|', 'ClearFormat', 'Print',
                'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'
              ],
              table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
                };  


                public simpleToolBar_note_template_owner: object = {
                  type: 'Expand',
                  enableFloating: false,
                  items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
                  'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
                  'LowerCase', 'UpperCase', '|',
                  {
                    tooltipText: 'Insert Widget',
                    undo: true,
                    click: this.onClickPromotionButton_OwnerNote_Template.bind(this),
                    template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
                  },
                  'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
                  'Outdent', 'Indent', '|',
                  'CreateLink', '|', 'ClearFormat', 'Print',
                  'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'
                ],
                table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
                  };               


                  public simpleToolBar_note_privacy_template_owner: object = {
                    type: 'Expand',
                    enableFloating: false,
                    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
                    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
                    'LowerCase', 'UpperCase', '|',
                    {
                      tooltipText: 'Insert Widget',
                      undo: true,
                      click: this.onClickPromotionButton_OwnerNotePrivacy_Template.bind(this),
                      template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
                    },
                    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
                    'Outdent', 'Indent', '|',
                    'CreateLink', '|', 'ClearFormat', 'Print',
                    'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'
                  ],
                  table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
                    };         
                  
   public simpleToolBar_note_template_client: object = {
                      type: 'Expand',
                      enableFloating: false,
                      items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
                      'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
                      'LowerCase', 'UpperCase', '|',
                      {
                        tooltipText: 'Insert Widget',
                        undo: true,
                        click: this.onClickPromotionButton_ClientNote_Template.bind(this),
                        template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
                      },
                      'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
                      'Outdent', 'Indent', '|',
                      'CreateLink', '|', 'ClearFormat', 'Print',
                      'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'
                    ],
                    table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
                      };    

  public simpleToolBar_note_privacy_template_client: object = {
    type: 'Expand',
    enableFloating: false,
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    {
      tooltipText: 'Insert Widget',
      undo: true,
      click: this.onClickPromotionButton_ClientNotePrivacy_Template.bind(this),
      template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
    },
    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat', 'Print',
    'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'
  ],
  table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
    };   

    
  public simpleToolBar_note_template_agent: object = {
    type: 'Expand',
    enableFloating: false,
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    {
      tooltipText: 'Insert Widget',
      undo: true,
      click: this.onClickPromotionButton_AgentNote_Template.bind(this),
      template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
    },
    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat', 'Print',
    'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'
  ],
  table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
    };   
       
    

    public simpleToolBar_note_privacy_template_agent: object = {
      type: 'Expand',
      enableFloating: false,
      items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
      'LowerCase', 'UpperCase', '|',
      {
        tooltipText: 'Insert Widget',
        undo: true,
        click: this.onClickPromotionButton_AgentNotePrivacy_Template.bind(this),
        template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
      },
      'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
      'Outdent', 'Indent', '|',
      'CreateLink', '|', 'ClearFormat', 'Print',
      'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'
    ],
    table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
      };   
    
                           

  public size = {
      width: '40px',
      items: [{ text: '8', value: '8pt' },
      { text: '10', value: '10pt' },
      { text: '12', value: '12pt' },
      { text: '14', value: '14pt' },
      { text: '42', value: '42pt' }]
  };
  public family = {
      width: '60px',
      items: [
      { text: 'Segoe UI', value: 'Segoe UI' },
      { text: 'Arial', value: 'Arial,Helvetica,sans-serif' },
      { text: 'Courier New', value: 'Courier New,Courier,monospace' },
      { text: 'Georgia', value: 'Georgia,serif' },
      { text: 'Impact', value: 'Impact,Charcoal,sans-serif' },
      { text: 'Calibri Light', value: 'CalibriLight' }]
  };


  public dataVariables: { [key: string]: Object }[] = [
    // { Id: '2', Name: 'FirstName' },
    // { Id: '2', Name: 'LastName' },
    // { Id: '3', Name: 'MiddleName' }
  
  // :: Owner mergeOwnerData
  { Id: '', Category: 'Owner', Name: 'Owner Business Name', insertValue: '${owner_business_name}', description: '' },
  { Id: '', Category: 'Owner', Name: 'Owner Phone', insertValue: '${owner_phone}', description: '' },
  { Id: '', Category: 'Owner', Name: 'Owner Address 1', insertValue: '${owner_address_1}', description: '' },
  { Id: '', Category: 'Owner', Name: 'Owner Address 2', insertValue: '${owner_address_2}', description: '' },
  { Id: '', Category: 'Owner', Name: 'Owner Suburb', insertValue: '${owner_suburb}', description: '' },
  { Id: '', Category: 'Owner', Name: 'Owner State', insertValue: '${owner_state}', description: '' },
  { Id: '', Category: 'Owner', Name: 'Owner Postcode', insertValue: '${owner_postcode}', description: '' },
  { Id: '', Category: 'Owner', Name: 'Owner Country', insertValue: '${owner_country}', description: '' },
  { Id: '', Category: 'Owner', Name: 'Owner Type', insertValue: '${owner_brand_type_id}', description: '' },
  ];
  
  
  public dataVariablesOrder: { [key: string]: Object }[] = [
  // :: WordPress Order mergeOwnerData
  { Id: '', Category: 'Order', Name: 'OrderID', insertValue: '${order_id}', description: '' },
  { Id: '', Category: 'Order', Name: 'Order Company Output', insertValue: '${order_shipping_company_output}', description: '' },
  { Id: '', Category: 'Order', Name: 'Order Company', insertValue: '${order_shipping_company}', description: '' },
  { Id: '', Category: 'Order', Name: 'First Name Abrv.', insertValue: '${order_shipping_first_name_abr}', description: '' },
  { Id: '', Category: 'Order', Name: 'First Name', insertValue: '${order_shipping_first_name}', description: '' },
  { Id: '', Category: 'Order', Name: 'Surname', insertValue: '${order_shipping_first_name}', description: '' },
  
  { Id: '', Category: 'Order', Name: 'Address Line 1', insertValue: '${order_shipping_address_1}', description: '' },
  { Id: '', Category: 'Order', Name: 'Address Line 2', insertValue: '${order_shipping_address_2}', description: '' },
  { Id: '', Category: 'Order', Name: 'City', insertValue: '${order_shipping_city}', description: '' },
  { Id: '', Category: 'Order', Name: 'State', insertValue: '${order_shipping_state}', description: '' },
  { Id: '', Category: 'Order', Name: 'Postcode', insertValue: '${order_shipping_postcode}', description: '' },
  { Id: '', Category: 'Order', Name: 'Country Abrv.', insertValue: '${order_shipping_country}', description: '' },
  
  
  
  { Id: '', Category: 'Order', Name: 'Shipping Method', insertValue: '${shipping_data_method_title}', description: '' },
  { Id: '', Category: 'Order', Name: 'Shipping Total', insertValue: '${shipping_data_total}', description: '' },
  
  { Id: '', Category: 'Order', Name: 'Customm Postage Output', insertValue: '${owner_brand_type_id}', description: '' },
  { Id: '', Category: 'Order', Name: 'Order Items Table', insertValue: '${items}', description: '' },
  { Id: '', Category: 'Order', Name: 'Order Items Table Alternative', insertValue: '${items2}', description: '' },
  
  { Id: '', Category: 'Order', Name: 'Item Full - CodeOutPut', insertValue: '${item_full}', description: '' },
  { Id: '', Category: 'Order', Name: 'CurrentID', insertValue: '${id}', description: '' },
  
  ];
  
  
  
  public dataVariablesOrderSender: { [key: string]: Object }[] = [
    // :: WordPress Order mergeOwnerData
    { Id: '', Category: 'Order', Name: 'Order From Company Output', insertValue: '${order_from_shipping_company_output}', description: '' },
    { Id: '', Category: 'Order', Name: 'Order From Company', insertValue: '${order_from_shipping_company}', description: '' },
    // { Id: '', Category: 'Order', Name: 'First Name Abrv.', insertValue: '${order_shipping_first_name_abr}', description: '' },
    // { Id: '', Category: 'Order', Name: 'First Name', insertValue: '${order_shipping_first_name}', description: '' },
    // { Id: '', Category: 'Order', Name: 'Surname', insertValue: '${order_shipping_first_name}', description: '' },
    
    { Id: '', Category: 'Order', Name: 'From Address Line 1', insertValue: '${order_from_shipping_address_1}', description: '' },
    { Id: '', Category: 'Order', Name: 'From Address Line 2', insertValue: '${order_from_shipping_address_2}', description: '' },
    { Id: '', Category: 'Order', Name: 'From City', insertValue: '${order_from_shipping_city}', description: '' },
    { Id: '', Category: 'Order', Name: 'From State', insertValue: '${order_from_shipping_state}', description: '' },
    { Id: '', Category: 'Order', Name: 'From Postcode', insertValue: '${order_from_shipping_postcode}', description: '' },
    { Id: '', Category: 'Order', Name: 'From Country Abrv.', insertValue: '${order_from_shipping_country}', description: '' },
    
    
    ];
  
  
    public dataVariablesOrderPickList: { [key: string]: Object }[] = [
      // :: WordPress Order mergeOwnerData
      { Id: '', Category: 'Order', Name: 'Pick List Title', insertValue: '${pick_list_title}', description: '' },
      { Id: '', Category: 'Order', Name: 'Today', insertValue: '${now_today}', description: '' },
      
      { Id: '', Category: 'Order', Name: 'Created - TimeStamp Words', insertValue: '${now_full_words}', description: '' },
      { Id: '', Category: 'Order', Name: 'Pick List Table Header', insertValue: '${pick_list_items_header}', description: '' },
      { Id: '', Category: 'Order', Name: 'Pick List Items (All) Table', insertValue: '${pick_list_items}', description: '' },
      { Id: '', Category: 'Order', Name: 'Pick List Items (Ebay) Table', insertValue: '${pick_list_ebay_items}', description: '' },
      { Id: '', Category: 'Order', Name: 'Pick List Items (WooCheckout) Table', insertValue: '${pick_list_checkout_items}', description: '' },
      { Id: '', Category: 'Order', Name: 'Pick List Key - Definition', insertValue: '${pick_list_key}', description: '' },
  
      ];

//define the country DropDownList data
public countryData: { [key: string]: Object }[] = [
  { CountryName: 'Australia', CountryId: '2' },
  { CountryName: 'United States', CountryId: '1' }
];
//define the state DropDownList data
public placeHolderdata: { [key: string]: Object }[] = [
  { StateName: 'US state -1', CountryId: '1', SateId: '101' },
  { StateName: 'US state -2 ', CountryId: '1', SateId: '102' },
  { StateName: 'Australia State -1 ', CountryId: '2', SateId: '105' },
  { StateName: 'Australia State -2', CountryId: '2', SateId: '106' },
  { StateName: 'US state -3 ', CountryId: '1', SateId: '108' },
  { StateName: 'Australia State -3 ', CountryId: '2', SateId: '109' },
  { StateName: 'url', SateId: 'url',CountryId: '0'},
{ StateName: 'userid', SateId: 'userid',CountryId: '0'},
{ StateName: 'username.loginemail', SateId: 'username.loginemail',CountryId: '0'},
{ StateName: 'emailotp', SateId: 'emailotp', EntityId:0 ,CountryId: '0' },
{ StateName: 'emailotpvalidaity', SateId: 'emailotpvalidaity',CountryId: '0' },
{ StateName: 'password', SateId: 'password',CountryId: '0' }
];

public countryFields: Object = { text: 'CountryName', value: 'CountryId' };






  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, private toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router, 
     public HttpClient: HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService
  ) { 
    



// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
this.current_base_route = this.router.url.substr(0, this.router.url.lastIndexOf('/'));


// Dynamic Variables
this.search_model = {
  is_active: 1,
  // job_type_id: res.job_type_id,
  // variable_code_block_type_id: res.variable_code_block_type_id,
  // job_type_location_id: res.job_type_location_id,
  // job_type_court_id: res.job_type_court_id,
  // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
  // "variable_code_block_insert_type_id": 2, //pdfs only

 };
 this.getVariableCodeBlocksSearchFull(this.search_model)


            // ... luxon   :: test Area And Dates Setps and establishments.
                      // const DST = 1472688000000; // 2016-09-01T00:00:00Z
                      // const notDST = 1480550400000; // 2016-12-01T00:00:00Z

                      // // DateTime.local().resolvedLocaleOpts();
                      // // { "locale": "en-US", "numberingSystem": "latn", "outputCalendar": "gregory" }

                      // const tz = 'America/Los_Angeles';

                      // Settings.defaultLocale = 'ja';
                      // Settings.defaultZoneName = tz;

                      // this.DSTs = [
                      //   DateTime.fromMillis(DST),

                      //   // 以下2つは同じ
                      //   // DateTime.fromMillis(DST).setLocale('en').setZone(tz),
                      //   DateTime.fromMillis(DST, { locale: 'en', zone: tz, })
                      // ];

                      // // DateTime.locale()以外の場合は、`zone`の設定が必要
                      // this.notDSTs = [
                      //   DateTime.fromMillis(notDST),
                      //   DateTime.fromMillis(notDST, { locale: 'en', zone: tz, })
                      // ];

                      // console.log(DateTime.local().zoneName);
                      // // -> America/Los_Angeles
                      // console.log(DateTime.local(2016, 9, 1).toString());
                      // // -> 2016-09-01T00:00:00.000-07:00

                      // // サマータイム(DST)の確認
                      // ['2016-09-01', '2016-12-01'].forEach(iso => {
                      //   console.log(iso,
                      //     (
                      //       DateTime.fromISO(iso, { zone: tz }).valueOf()
                      //       - DateTime.fromISO(iso).valueOf()
                      //     ) / 60000
                      //   );
                      // })

                      // console.log(
                      //   DateTime.local(2016, 9, 1).valueOf()
                      //   !== DateTime.fromISO('2016-09-01').valueOf()
                      // );
                      // // -> true

                      // console.log(
                      //   DateTime.fromString('5月 25日 1982', 'LLLL dd yyyy').toISO()
                      // );

            // ... end Luxon





  }

  ngOnInit(): void {
    
  }

 // check for changes. to load data.
 ngOnChanges(changes) {

this.model = this.item_data;
console.log("Selected Field " + this.current_field_name);
this.getVariableCodeBlocksSearchFull(this.search_model)



// this.opened();
    // this.set_value = this.model.email_template_agent;

    // // Set the form field name
    // this.field_name = 'model.' + this.current_field_name;




if (changes.item_id) {
    // deal with asynchronous Observable result
    this.user_id = changes.item_id.currentValue;
   //  this.getBrandById(this.brand_id);
   this.baseUploadURL = this.gfunc.baseUploadURL_UserAssets + '/' + this.user_id; // no trailing
  //  this.getUserById(this.user_id);
  //  this.getLogsCreatedBy(this.user_id);



  }
}

getUserById(user_id) {

  this._demoService.getUsersById(user_id).subscribe(
     data => { this.users = data;
      this.brand_id = this.users.map(function(a) {return a ['brand_id']; });
      this.access_level = this.users.map(function(a) {return a ['access_level']; });
      this.user_password_expiry_date = this.users.map(function(a) {return a ['password_expiry_date']; });

      this.getBrand(this.brand_id);
      this.getFormUserLevel(this.access_level);
      this.baseBrandUploadURL = this.gfunc.baseUploadURL_BrandAssets + '/'  + this.brand_id; // no trailing
      // console.log(data);

      // check password expirty
     // agent qualification cheker
console.log('User Password Last Updated Date: ', this.user_password_expiry_date);

// this.metric_qualification_renewal_date = new Date(this.brand_data[0].qualification_renewal_date * 1000);
this.metric_password_date = new Date(this.user_password_expiry_date);
console.log('this.metric_password_date: ', this.metric_password_date);
// this.metric_qualification_renewal_date = brand_data[0].qualification_renewal_date;
this.today_format = new Date(this.gfunc.today);
// this.openModalWithComponent_PasswordExpired();


// Now checks if a valid date - so if I remove all password dates it will pop up
if(this.metric_password_date.toString() === 'Invalid Date') {
  console.log('Invalid date string');
  console.log('Passord has been expired. Date of keys no longer valid.');
  this.user_password_date_status_expired = 1;
  this.openModalWithComponent_PasswordExpired();
} else {
  console.log('Valid date string');
}


// if (!this.metric_password_date) {
// console.log('Password date invalide mate.')
// }

if (this.metric_password_date <= this.today_format) {
  console.log('NOTICE: This users password has expired');
  // this.user_password_date_status_expired = 1;
  // this.openModalWithComponent_PasswordExpired();
}

    },
     err =>{ 
      console.log('API Key has been revoked and not valid or our API is down.');
      // this.user_password_date_status_expired = 1;
      // this.openModalWithComponent_PasswordExpired();
      
      console.error(err)},
     () => console.log(' Loaded.')
   );
}

private getLogsCreatedBy(created_by) {
  this._demoService.fetchSystemLogCreatedBy(created_by).subscribe(
    data => {
      this.userLogs = data;
      let res = data[0];
      // need to do some calcs and return the array for sparkle - TSA Activity Line
      // group items into arrays of days, and then count items for each day,
      // do a total of 30 days and see what it looks like - > max 30 days activity.
      let  count_of_items = Object.keys(this.userLogs).length;
      this.count_of_items = count_of_items;
      // need to get the count of items per particular date ()
      const set_counter_count = 15; // equates to last 15 days a user has activity
      // later include empty days as zeros to display true, in-activity.

      // filter for a day (Need to establish the last date, then do a special function to get (or use today,and get real blanks)

      //  (or get day 1 from last entry... and count back... day -1) in a loop)

      let today = this.gfunc.today;
      this.metric_1_data = this.userLogs.filter((sbi)=>(sbi.service_number === '1'));


      for(let i=0; i < count_of_items; i++) {
        let res2 = this.userLogs[i];
          // filter for a day (Need to establish the last date, then do a special function to get (or use today,and get real blanks)


      } // end loop


      // need to set the user password expirty check.


    },
    err => console.error(err)
  );
} /* */


// private getBrandMysql(brand_id) {
// this._mysqlService.getMysqlBrandDatas(brand_id)
//   .subscribe(
//     res => this.brandMysql = res,
//     err => console.error(err.status)
//   );
// }
 

   // MODAL view a component
   openModalWithComponent_PasswordExpired() {
  //   const initialState = {
  //     title: 'Your Password Has Expired!',
  //     item_id: 1010,
  //     user_id: this.user_id,
  //     size: 'lg',
  //     backdrop: true,
  //     IgnoreBackdropClick: true,
  //     keyboard: false,
  //   };
    
  //   this.bsModalRef = this.modalService.show(UserPasswordExpiredModalComponent, {initialState});
  //   // sets the var to in the component model
  //   this.bsModalRef.content.user_id = this.user_id;
  //  // this.bsModalRef.content.brand_id = this.brand_id;
  //   this.bsModalRef.content.item_id = this.user_id;
  //   this.bsModalRef.content.closeBtnName = 'Logout';
  //   // subscribed to the emitter and get the value.
  //   this.bsModalRef.content.action.take(1).subscribe((value) => {
  // // console.log(value); // here you will get the value of the file
  // // Remove the "uploads/" part from the filename.
  //               // this.filenameselected = value;
  //               // this.stripped = this.filenameselected.replace('uploads/', '');
  //               // // this.model.main_image = this.stripped; // works for simple add not update.
  //               // // console.log(this.stripped);
  //               // // console.log(this.model);
  //               // this.form.photo = this.stripped;
  //               // // this.form.reset();
  //               // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
  //               // this.form.controls['photo'].patchValue(this.form.photo);
  // });


  const config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    ignoreBackdropClick: true,
  };
  this.bsModalRef = this.modalService.show(UserPasswordExpiredModalComponent, config);
    // sets the var to in the component model
    this.bsModalRef.content.user_id = this.user_id;
   // this.bsModalRef.content.brand_id = this.brand_id;
    this.bsModalRef.content.item_id = this.user_id;
    this.bsModalRef.content.closeBtnName = 'Logout';
   }




getFormUserLevel(level) {
this._demoService.getUserLevel(level).subscribe(
   data => { this.user_level = data;
    console.log(data);
 },
   err => console.error(err),
   () => console.log('done loading User Levels')
 );
}




addDays(days : number): Date {
  let futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + days);
  return futureDate;
  }

  removeDays(days : number): Date {
  let futureDate = new Date();
  futureDate.setDate(futureDate.getDate() - days);
  return futureDate;
  }


  
  private getBrand(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
    data => { this.brand_data = data;

// agent qualification cheker
console.log('Agent Qualification Renewal Date: ', data[0].qualification_renewal_date);

// this.metric_qualification_renewal_date = new Date(this.brand_data[0].qualification_renewal_date * 1000);
this.metric_qualification_renewal_date = new Date(this.brand_data[0].qualification_renewal_date);
// this.metric_qualification_renewal_date = brand_data[0].qualification_renewal_date;
this.today_format = new Date(this.gfunc.today);

if (this.metric_qualification_renewal_date <= this.today_format) {
  console.log('NOTICE: This agent qualification has expired');
  this.agent_qualification_status_expired = 1;
}

      // this.allClientEmailRecipients = data;

    },
     err => console.error(err),
     () => console.log('Brand Loaded.')
   );
  }


  //  // MODAL
  // // start of modal windows service as a template
  // openModal(template: TemplateRef<any>) {
  //   // small upgrade to disable background click on open modal background
  //   const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  //   this.modalRef = this.modalService.show(template, config);
  // }
  
  // // :: Parent / Child modal test
  // closeParentModel() {
  //   // alert('parent component function.');
  //   this.modalRef.hide();
  //  // this.refreshGrid(); // resets the grid if updated and closed.
  // //  this.updateTypeClick = false; // closes the div
  // };
  


// Create new Insert Button - Designer Variables - Simple HTML -- or do I load all the variables into the database.???? JSON>... then I can loop.


  public onClickPromotionButton() {
    // this.rteObj.focusIn();
    this.openModalWithComponent_Promotion();
}

public onClickPromotionButton_paragraphTemplate() {
  // this.rteObj.focusIn();
  this.openModalWithComponent_Promotion_paragraphTemplate();
}


public onClickPromotionButton_ClientEmail_Template() {
  // this.rteObj.focusIn();
  this.openModalWithComponent_ClientEmail_paragraphTemplate();
}


public onClickPromotionButton_ClientEmailPrivacy_Template() {
  // this.rteObj.focusIn();
  this.openModalWithComponent_ClientEmailPrivacy_paragraphTemplate();
}


public onClickPromotionButton_OwnerEmail_Template() {
  // this.rteObj.focusIn();
  this.openModalWithComponent_OwnerEmail_paragraphTemplate();
}

public onClickPromotionButton_OwnerEmailPrivacy_Template() {
  // this.rteObj.focusIn();
  this.openModalWithComponent_OwnerEmailPrivacy_paragraphTemplate();
}


public onClickPromotionButton_AgentEmail_Template() {
  // this.rteObj.focusIn();
  this.openModalWithComponent_AgentEmail_paragraphTemplate();
}

public onClickPromotionButton_AgentEmailPrivacy_Template() {
  // this.rteObj.focusIn();
  this.openModalWithComponent_AgentEmailPrivacy_paragraphTemplate();
}

    public onClickPromotionButton_OwnerNote_Template() {
      // this.rteObj.focusIn();
      this.openModalWithComponent_OwnerNote_paragraphTemplate();
    }


    public onClickPromotionButton_OwnerNotePrivacy_Template() {
      // this.rteObj.focusIn();
      this.openModalWithComponent_OwnerNotePrivacy_paragraphTemplate();
    }  

    public onClickPromotionButton_ClientNote_Template() {
      // this.rteObj.focusIn();
      this.openModalWithComponent_ClientNote_paragraphTemplate();
    }


    public onClickPromotionButton_ClientNotePrivacy_Template() {
      // this.rteObj.focusIn();
      this.openModalWithComponent_ClientNotePrivacy_paragraphTemplate();
    } 



    
    public onClickPromotionButton_AgentNote_Template() {
      // this.rteObj.focusIn();
      this.openModalWithComponent_AgentNote_paragraphTemplate();
    } 



    public onClickPromotionButton_AgentNotePrivacy_Template() {
      // this.rteObj.focusIn();
      this.openModalWithComponent_AgentNotePrivacy_paragraphTemplate();
    } 

    

     // MODAL view a component
     openModalWithComponent_Promotion() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: this.subject_template_doc,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }

    openModalWithComponent_ClientEmailPrivacy_paragraphTemplate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "email_privacy_template_client"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'email_privacy_template_client',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }


    openModalWithComponent_ClientEmail_paragraphTemplate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "email_template_client"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'email_template_client',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }

    // MODAL view a component
    openModalWithComponent_Promotion_paragraphTemplate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "manual_paragraph_rendered"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'manual_paragraph_rendered',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }


    openModalWithComponent_OwnerEmail_paragraphTemplate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "email_template_owner"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'email_template_owner',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }


    openModalWithComponent_OwnerEmailPrivacy_paragraphTemplate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "email_privacy_template_owner"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'email_privacy_template_owner',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }



    openModalWithComponent_AgentEmail_paragraphTemplate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "email_template_agent"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'email_template_agent',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }


    openModalWithComponent_AgentEmailPrivacy_paragraphTemplate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "email_privacy_template_agent"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'email_privacy_template_agent',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }


    openModalWithComponent_OwnerNote_paragraphTemplate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "note_template_owner"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'note_template_owner',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }


    openModalWithComponent_OwnerNotePrivacy_paragraphTemplate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "note_privacy_template_owner"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'note_privacy_template_owner',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }  


    openModalWithComponent_ClientNote_paragraphTemplate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "note_template_client"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'note_template_client',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }



    openModalWithComponent_ClientNotePrivacy_paragraphTemplate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "note_privacy_template_client"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'note_privacy_template_client',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    } 

    openModalWithComponent_AgentNote_paragraphTemplate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "note_template_agent"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'note_template_agent',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }



    openModalWithComponent_AgentNotePrivacy_paragraphTemplate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "note_privacy_template_agent"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'note_privacy_template_agent',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    } 

    

   // this willl have to be avariable.
        // :: Parent / Child modal test
        public insertPromotionFromModal(fileurl) {
          // alert('Clicked Insert');
    
    
                  // Try wrapping an image tag around the image before inserting.
                  // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
                  // auto inserts the variable name of theat which was sent.
                  let insert_tag = 'NOT USED -- {{' + fileurl + '}}'
    
          // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
          this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
          // InsertHtml.Insert(document, document.createTextNode(fileurl));
          InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
          // InsertHtml.Insert(document, document.createElement('image') )
    
    
          // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
    
    
          // insertImage(fileurl);
    
          // has to be correct form name
        // this.modalRef.hide();
        // console.log('Added External Recipeint.');
        // this.toastr.info('External Recipient Added');
        };
  
  
        public insertStrFromModal(fileurl) {
          // alert('Clicked Insert');
    
    
                  // Try wrapping an image tag around the image before inserting.
                  // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
                  // auto inserts the variable name of theat which was sent.
                  let insert_tag = '' + fileurl + ''
    
          // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
          this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
          // InsertHtml.Insert(document, document.createTextNode(fileurl));
          InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
          // InsertHtml.Insert(document, document.createElement('image') )
    
    
          // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
    
    
          // insertImage(fileurl);
    
          // has to be correct form name
        // this.modalRef.hide();
        // console.log('Added External Recipeint.');
        // this.toastr.info('External Recipient Added');
        };
  
  
        public insertVariableFromModal(fileurl) {
          // alert('Clicked Insert');
    
    
                  // Try wrapping an image tag around the image before inserting.
                  // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
                  // auto inserts the variable name of theat which was sent.
                //  pps
                  // let insert_tag = '${' + fileurl + '}'

                  // sharmans
                  let insert_tag = fileurl;


          // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
          this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
          // InsertHtml.Insert(document, document.createTextNode(fileurl));
          InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
          // InsertHtml.Insert(document, document.createElement('image') )
    
    
          // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
    
    
          // insertImage(fileurl);
    
          // has to be correct form name
        // this.modalRef.hide();
        // console.log('Added External Recipeint.');
        // this.toastr.info('External Recipient Added');
        };




        public insertImageQRFromModal(fileurl) {
          // alert('Clicked Insert');
    
    
                  // Try wrapping an image tag around the image before inserting.
                  // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
    
                  // let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="https://ppsdistrohub.nickbowen.com.au/APP_PHP/uploads/' + fileurl + '" >'

                                  // april 28 2023 - now in assets of brand.
                let link = this.gfunc.baseUploadURL_BrandAssets + '/' + this.brand_id + '/qrcodes/' + fileurl;
                let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="'+ link + '" >'
  
                  // let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src=" https://ppsdistrohub.nickbowen.com.au/APP_PHP/uploads/' + fileurl + '" >'
    
          // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
          this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
          // InsertHtml.Insert(document, document.createTextNode(fileurl));
          InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
          // InsertHtml.Insert(document, document.createElement('image') )
    
    
          // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
    
    
          // insertImage(fileurl);
    
          // has to be correct form name
        // this.modalRef.hide();
        // console.log('Added External Recipeint.');
        // this.toastr.info('External Recipient Added');
        };
  

  // Now workes for multiple editors on a page... few!! 11pm 2/12/23
  public insertVariableFromModal_EditorID(fileurl) {
    // alert('Clicked Insert');

    console.log(JSON.stringify(fileurl))
    let editorID = fileurl.editorID
    let insert_variable = fileurl.fileurl

    this.toastr.info('Variable Inserted: ' + insert_variable)

    // this.toastr.info('editorID: ' + editorID)

            // Try wrapping an image tag around the image before inserting.
            // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
            // auto inserts the variable name of theat which was sent.
          //  pps
            // let insert_tag = '${' + fileurl + '}'

            // sharmans
    // let insert_tag = fileurl;
    // this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
    // InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI


        // // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
        // this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
        // // InsertHtml.Insert(document, document.createTextNode(fileurl));
        // InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
        // // InsertHtml.Insert(document, document.createElement('image') )

        // // Need an if statment and to get the Editor ID , to have muliple occurannces on one page.

      
                // if (editorID == 'emailSubjectTemplate'){  
                //   // Now adds to the subject
                //   let currentValue =   this.form.controls['email_subject_primary'].value;
                //   let newValue = '';
                //   if(currentValue == null){
                //     newValue = insert_variable;
                //   }else{
                //     newValue = currentValue + ' ' + insert_variable;
                //   }
                //   this.form.controls['email_subject_primary'].patchValue(newValue);
                // }

                // if (editorID == 'emailSubjectTemplatePrivate'){  
                //   // Now adds to the subject
                //   let currentValue =   this.form.controls['email_subject_private'].value;
                //   let newValue = '';
                //   if(currentValue == null){
                //     newValue = insert_variable;
                //   }else{
                //     newValue = currentValue + ' ' + insert_variable;
                //   }
                //   this.form.controls['email_subject_private'].patchValue(newValue);
                // }


                if (editorID == 'manual_paragraph_rendered'){
              this.paragraphTemplateEditor.focusIn(); // these two lines work for RichTextEditor
              InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
              } 

              if (editorID == 'email_template_client'){
                this.email_template_client.focusIn(); // these two lines work for RichTextEditor
                InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
                }   

                if (editorID == 'email_privacy_template_client'){
                  this.email_privacy_template_client.focusIn(); // these two lines work for RichTextEditor
                  InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
                  }    

              if (editorID == 'email_template_owner'){
                this.email_template_owner.focusIn(); // these two lines work for RichTextEditor
                InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
                } 



                if (editorID == 'email_privacy_template_owner'){
                  this.email_privacy_template_owner.focusIn(); // these two lines work for RichTextEditor
                  InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
                  } 
  


              if (editorID == 'email_template_agent'){
                this.email_template_agent.focusIn(); // these two lines work for RichTextEditor
                InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
                }   
              

             
                if (editorID == 'email_privacy_template_agent'){
                  this.email_privacy_template_agent.focusIn(); // these two lines work for RichTextEditor
                  InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
                  }  


                  if (editorID == 'note_template_owner'){
                    this.note_template_owner.focusIn(); // these two lines work for RichTextEditor
                    InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
                    }      
                   
                    if (editorID == 'note_privacy_template_owner'){
                      this.note_privacy_template_owner.focusIn(); // these two lines work for RichTextEditor
                      InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
                      }   

                      if (editorID == 'note_template_client'){
                        this.note_template_client.focusIn(); // these two lines work for RichTextEditor
                        InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
                        }   


                        if (editorID == 'note_privacy_template_client'){
                          this.note_privacy_template_client.focusIn(); // these two lines work for RichTextEditor
                          InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
                          }  
                          
                          

                          if (editorID == 'note_template_agent'){
                            this.note_template_agent.focusIn(); // these two lines work for RichTextEditor
                            InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
                            }  
  
  
                            if (editorID == 'note_privacy_template_agent'){
                              this.note_privacy_template_agent.focusIn(); // these two lines work for RichTextEditor
                              InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
                              }  
    
                                     

                        
                                          

            // if (editorID == 'emailTemplate'){
            //   this.emailTemplateEditor.focusIn(); // these two lines work for RichTextEditor
            //   InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
            //   } 
              
            //   if (editorID == 'emailTemplatePrivate'){
            //     this.emailTemplateEditorPrivate.focusIn(); // these two lines work for RichTextEditor
            //     InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
            //     }    

            //       // NoteTemplate Editor.
            //  if (editorID == 'noteTemplate'){
            //   this.noteTemplateEditor.focusIn(); // these two lines work for RichTextEditor
            //   InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
            //  }

            //       // NoteTemplate Editor.
            //       if (editorID == 'noteTemplatePrivate'){
            //         this.noteTemplateEditorPrivate.focusIn(); // these two lines work for RichTextEditor
            //         InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
            //        }
                

             if (editorID == 'defaultRTE'){
              this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
              InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
             }
    // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 


    // insertImage(fileurl);

    // has to be correct form name
  // this.modalRef.hide();
  // console.log('Added External Recipeint.');
  // this.toastr.info('External Recipient Added');
  };



    // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
  // WORKS as I created my own function from this articel == pretty well convers
  transform2(value: any, args?: any): any {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    return doc.documentElement.textContent;
  }



  // :: Parent / Child modal test
  public insertImageFromModal(fileurl) {
    // alert('Clicked Insert');


            // Try wrapping an image tag around the image before inserting.
            // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">

            let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="' + fileurl + '" >'

    // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
    this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
    // InsertHtml.Insert(document, document.createTextNode(fileurl));
    InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
    // InsertHtml.Insert(document, document.createElement('image') )


    // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 


    // insertImage(fileurl);

    // has to be correct form name
  // this.modalRef.hide();
  // console.log('Added External Recipeint.');
  // this.toastr.info('External Recipient Added');
  };


  public onCreate(): void { 
    let data: { [key: string]: Object }[] = [
        { Id: '2', Name: 'FirstName' },
        { Id: '2', Name: 'LastName' },
        { Id: '3', Name: 'MiddleName' }
    ];
    let proxy = this.rteObj;
     let dropdownVariables: DropDownList = new DropDownList({
        dataSource: data,
        fields: { text: 'Name' },
        placeholder: 'Insert Fields',
        width: '100px',
        change: (args: any)=>{
          proxy.focusIn();
          InsertHtml.Insert(document, document.createTextNode(args.value));
        }
    });
    dropdownVariables.appendTo('#dropdownVariables');
    
    
    } 


    // see if this changes the below mode.
    public onChangeHTML(args): void { 
      this.proxy = this.defaultRTE;
       this.model = this.model;

    }


    public onCreate2(): void { 
      this.proxy = this.defaultRTE;
      // initialize Custom DropDownList component
       this.dropdownVariables = new DropDownList({
        dataSource: this.dataVariables,
        fields: { text: 'Name', value: 'insertValue' },
        // fields: { text: 'Name' },
        placeholder: 'My Details',
        width: '300px',
        change: (args: any)=>{
          this.defaultRTE.focusIn();
          InsertHtml.Insert(document, document.createTextNode(args.value));
        }
      });
      this.dropdownVariables.appendTo('#dropdownVariables');


      this.dropdownVariablesDynamic = new DropDownList({
        allowFiltering: true, 
        filtering: (args: any)=>{this.onFiltering_dynamic(args.value)},
        dataSource: this.dynamic_data,
        // fields: { text: 'Name', value: 'insertValue' },
        fields: this.job_fields_categories,
        
        // fields: { text: 'Name' },
        placeholder: 'Dynamic Variables',
        width: '450px',
        change: (args: any)=>{
          this.defaultRTE.focusIn();
          InsertHtml.Insert(document, document.createTextNode(args.value));
        }
      });
      this.dropdownVariablesDynamic.appendTo('#dropdownVariablesDynamic');


      this.dropdownVariablesOrder = new DropDownList({
        dataSource: this.dataVariablesOrder,
        fields: { text: 'Name', value: 'insertValue' },
        // fields: { text: 'Name' },
        placeholder: 'Order Variables',
        width: '300px',
        change: (args: any)=>{
          this.defaultRTE.focusIn();
          InsertHtml.Insert(document, document.createTextNode(args.value));
        }
      });
      this.dropdownVariablesOrder.appendTo('#dropdownVariablesOrder');

      this.dropdownVariablesOrderSender = new DropDownList({
        dataSource: this.dataVariablesOrderSender,
        fields: { text: 'Name', value: 'insertValue' },
        // fields: { text: 'Name' },
        placeholder: 'Order Sender',
        width: '300px',
        change: (args: any)=>{
          this.defaultRTE.focusIn();
          InsertHtml.Insert(document, document.createTextNode(args.value));
        }
      });
      this.dropdownVariablesOrderSender.appendTo('#dropdownVariablesOrderSender');


      this.dropdownVariablesOrderPickList = new DropDownList({
        dataSource: this.dataVariablesOrderPickList,
        fields: { text: 'Name', value: 'insertValue' },
        // fields: { text: 'Name' },
        placeholder: 'Pick List Items',
        width: '300px',
        change: (args: any)=>{
          this.defaultRTE.focusIn();
          InsertHtml.Insert(document, document.createTextNode(args.value));
        }
      });
      this.dropdownVariablesOrderPickList.appendTo('#dropdownVariablesOrderPickList');


      this.dropdownVariables_AutomationGeneral = new DropDownList({
        allowFiltering: true, 
        filtering: (args: any)=>{this.onFiltering_automationGeneral(args.value)},
        dataSource: this.automationGeneral_data,
        fields: { text: 'Name', value: 'insertValue' },
        // fields: { text: 'Name' },
        placeholder: 'Automation General',
        width: '450px',
        change: (args: any)=>{
          this.defaultRTE.focusIn();
          InsertHtml.Insert(document, document.createTextNode(args.value));
        }
      });
      this.dropdownVariables_AutomationGeneral.appendTo('#dropdownVariablesAutomationGeneral');

    }



    // This allows erfresh of the drop down data dynamically
    public onFiltering(args): void { 
      this.listObj.dataSource = this.job_dropdown_data; 
  } 


  public onFiltering_dynamic(args): void { 
    this.dropdownVariablesDynamic.dataSource = this.dynamic_data
} 

public onFiltering_automationGeneral(args): void { 
  this.dropdownVariables_AutomationGeneral.dataSource = this.automationGeneral_data
} 

    oncreated() {
      this.proxy = this;  
      // initialize Custom DropDownList component
       this.dropDownListObject = new DropDownList({
          placeholder: "Select PlaceHolder Value",
          width: "180px",
          fields: { text: 'StateName', value: "SateId" },
          // change: (args: any)=>{
          //   this.defaultRTE.focusIn();
          //   InsertHtml.Insert(document, document.createTextNode(args.value));
          // }
          change: this.OnChanged.bind(this),
          //set the data to dataSource property
          dataSource: this.placeHolderdata
      });
      this.dropDownListObject.appendTo('#ddlelement');
    }
    //Parent dropdown change event
  
        //pass the filter data source, filter query to updateData method.
    public countryChange(): void {
      let predicate = new Predicate('CountryId', 'equal', this.countryObj.value, true);
      predicate = predicate.or('CountryId', 'equal','0' ,true);
      let query: Query = new Query();
        //frame the query based on search string with filter type.
        query = query.where(predicate);
      // let tempQuery: Query = new Query().where('CountryId', 'equal', this.countryObj.value); // commented out in example
      //     this.dropDownListObject.query = tempQuery;
          this.dropDownListObject.query = query;
            this.dropDownListObject.text = null;
              this.dropDownListObject.dataBind();
              this.isParentDropdownChanged = true;
              
    }
    OnChanged(args) { 
      //Change the Rich Text Editor placeholder
      // this.defaultRTE.placeholder = args.value;
      this.defaultRTE.focusIn();
      InsertHtml.Insert(document, document.createTextNode(args.value));


      this.RTEemail_template_owner.focusIn();
      InsertHtml.Insert(document, document.createTextNode(args.value));
  
    }
    clicked() {
      this.defaultDialog.show();
    }


// MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
//  this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};



// Dynamic Variables
getVariableCodeBlocksSearchFull(search_model) {
  // search_model.brand_type_id = 3;
  // search_model.access_level = 5;
  this._demoService.getVariableCodeBlocksSearchFull(search_model).subscribe(
    data => { this.variable_code_blocks_metrix_search_full = data;
     let res = data[0];
      // pass so that the dates are correct in Sync
      // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
     
     
      this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
      // this.subject_service_metrix_search_full_results = data;
      this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 500);


// Do while push objects to model...
let  count_of_items = this.new_data.length;
var dropdopwn_items = [];
for(let i=0; i < count_of_items; i++) {
  let itemData = this.new_data[i];
// push to array to fill below.
dropdopwn_items.push({ 
  Id: itemData.variable_code_block_id,
  Category: itemData.log_type_data_sector_name,
  Name: itemData.variable_code_block_name,
  insertValue: itemData.variable_code_block_as_variable,
  description: ''
});

}


// AUTOMATERION GENERAL VARIABLE ITEMS

// Set some fileters and create Arrays of drop down lists components for the drop down menu systems
let newArr = Object(data).filter((sbi)=>(sbi.log_type_data_sector_id == 8)); // User this if filter is needed.
// WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
var dropdown_GeneraAutomation = DataUtil.parse.parseJson(newArr);
let  count_GeneraAutomation = dropdown_GeneraAutomation.length;
var dropdopwn_items_GeneraAutomation = [];
for(let i=0; i < count_GeneraAutomation; i++) {
  let itemData2 = dropdown_GeneraAutomation[i];

  dropdopwn_items_GeneraAutomation.push({ 
    Id: itemData2.variable_code_block_id,
    Category: itemData2.log_type_data_sector_name,
    Name: itemData2.variable_code_block_name,
    insertValue: itemData2.variable_code_block_as_variable,
    description: ''
  });

}

// let  count_of_items = Object.keys(this.new_data).length;
//   // need to do a loop of subject_cost items (.length)
//   for(let i=0; i < count_of_items; i++) {
//     let itemData = this.row_data[i];

//     if(itemData[i].myob_tax_code_id == '1') {
//       this.row_data[i].tax = (itemData[i].cost_task_fee / (100 / 10)) * itemData[i].qty;
//     }
//     if(itemData[i].myob_tax_code_id == '2') {
//       this.row_data[i].tax = 0;
//     }
//   } // end for loop of count array



        // // Count items of brand search to loop through
        // let  count_of_brand_items = Object.keys(this.brand_search).length;
        // // now loop and push to join model
        // for(let i=0;i < count_of_brand_items; i++) {
        //   let res = this.brand_search[i];

        //     // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
        //     this.brand_user_join_results.push({
        //       email_address: res.email,
        //       first_name: res.name,
        //       surname: res.surname,
        //       company_name: res.name,
        //       created: res.created,
        //             });

        // } // end brands loop.







        // Setup DropDownMenu Data 
      let  dynamic_dropdown_data: { [key: string]: Object }[] =
[
...dropdopwn_items,
  // { Id: '', Category: 'Job', Name: 'Job Status', insertValue: '${job_status_code}', description: '' },
  // { Id: '', Category: 'Job', Name: 'Job Number', insertValue: '${job_number}', description: '' },
  // { Id: '', Category: 'Job', Name: 'Job Type', insertValue: '${job_type_name}', description: '' }, // replaced by name or business name
  // { Id: '', Category: 'Job', Name: 'Job Type Location', insertValue: '${job_type_location_name}', description: '' },
  // { Id: '', Category: 'Job', Name: 'Job Type Court', insertValue: '${job_type_court_name}', description: '' },
  // { Id: '', Category: 'Job', Name: 'Job Type Document Type', insertValue: '${job_type_document_type_name}', description: '' },
  // { Id: '', Category: 'Job', Name: 'Job Type Affidavit Type', insertValue: '${job_type_affidavit_type_name}', description: '' },
  // { Id: '', Category: 'Job', Name: 'Job Subject Type', insertValue: '${job_subject_type_name}', description: '' },
  // { Id: '', Category: 'Job', Name: 'Job Plaintiff Type', insertValue: '${job_plaintiff_type_name}', description: '' },
  // { Id: '', Category: 'Job', Name: 'Job Report Client Name', insertValue: '${job_client_report_name}', description: '' },
];

let  automationGeneral_dropdown_data: { [key: string]: Object }[] = [...dropdopwn_items_GeneraAutomation,
  // { Id: '', Category: 'Job', Name: 'Job Status', insertValue: '${job_status_code}', description: '' },
];

    
this.dynamic_data = dynamic_dropdown_data;
this.automationGeneral_data = automationGeneral_dropdown_data;
    //  this.grid.refresh();
 
    

      },
      error => {
      console.error('Error Loading !' + error.error);
      console.log(error);
      // return Observable.throw(error);
      }
      );
       

}






}



/*
import { DatePipe } from '@angular/common'
...
providers: [DatePipe]

'short': equivalent to 'M/d/yy, h:mm a' (6/15/15, 9:03 AM).
'medium': equivalent to 'MMM d, y, h:mm:ss a' (Jun 15, 2015, 9:03:01 AM).
'long': equivalent to 'MMMM d, y, h:mm:ss a z' (June 15, 2015 at 9:03:01 AM GMT+1).
'full': equivalent to 'EEEE, MMMM d, y, h:mm:ss a zzzz' (Monday, June 15, 2015 at 9:03:01 AM GMT+01:00).
'shortDate': equivalent to 'M/d/yy' (6/15/15).
'mediumDate': equivalent to 'MMM d, y' (Jun 15, 2015).
'longDate': equivalent to 'MMMM d, y' (June 15, 2015).
'fullDate': equivalent to 'EEEE, MMMM d, y' (Monday, June 15, 2015).
'shortTime': equivalent to 'h:mm a' (9:03 AM).
'mediumTime': equivalent to 'h:mm:ss a' (9:03:01 AM).
'longTime': equivalent to 'h:mm:ss a z' (9:03:01 AM GMT+1).
'fullTime': equivalent to 'h:mm:ss a zzzz' (9:03:01 AM GMT+01:00).


*/